import { Checkbox, createStyles, Typography } from '@quickbit/qb-design-system';
import React from 'react';

type Range = [string, string];

interface RangeCheckboxesProps {
  ranges: Range[];
  onChange: (selectedRange: number) => void;
  selected?: number;
}

export const RangeCheckboxes: React.FC<RangeCheckboxesProps> = ({
  ranges,
  onChange,
  selected,
}) => {
  const styles = useStyles();
  const onSelectRange = (range: Range) => {
    const [start, end] = range;
    const isInfinity = end === '+';
    const maxInt = isInfinity
      ? parseInt(start.replace(/,/g, ''), 10) + 1
      : parseInt(end.replace(/,/g, ''), 10);
    onChange(maxInt);
  };
  return (
    <div css={styles.container}>
      {ranges.map((range) => {
        const [start, end] = range;
        const isInfinity = end === '+';
        const maxInt = isInfinity
          ? parseInt(start.replace(/,/g, ''), 10) + 1
          : parseInt(end.replace(/,/g, ''), 10);
        const isChecked = selected === maxInt;
        return (
          <label key={start} css={styles.checkBoxItem}>
            <Checkbox
              checked={isChecked}
              onChange={() => onSelectRange(range)}
            />{' '}
            <div css={{ display: 'flex' }}>
              <Typography variant="bodySmallBold">{range[0]}&nbsp;</Typography>
              <Typography variant="bodySmallBold">-&nbsp;{end}</Typography>
            </div>
          </label>
        );
      })}
    </div>
  );
};

const useStyles = createStyles(({ spacing, breakpoints }) => ({
  container: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    [breakpoints.tabletSmall]: {
      flexDirection: 'row',
      justifyContent: 'flex-start',
    },
  },
  checkBoxItem: {
    display: 'flex',
    alignItems: 'center',
    gap: spacing.xxxs,
    justifyContent: 'flex-start',
    marginBottom: spacing.xxxs,
    [breakpoints.tabletSmall]: {
      flexDirection: 'column',
      marginRight: spacing.xs,
      alignItems: 'center',
    },
  },
}));
